const state = {
    avaiablePress: []
  };
  
  export default state;
  